import { useQuery } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import { GET_SINGLE_BUILDING_DATA } from '@/graphql/StatusQuoAnalysis.queries';
import { PATHS } from '@/routes';
import { useStatusQuoSelectionStorage } from '@/sections/StatusQuoAnalysis/useStatusQuoSelectionStorage';

export const useQueryGetSingleBuilding = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { storeBuildingSelection } = useStatusQuoSelectionStorage();

  const { data, loading, error } = useQuery(GET_SINGLE_BUILDING_DATA, {
    variables: { buildingId: Number(id) },
    skip: !id,
    onCompleted: (data) => {
      if (!data.building_by_pk) {
        return navigate(PATHS.notFound());
      }

      storeBuildingSelection(
        data.building_by_pk.id,
        data.building_by_pk.economic_unit.portfolio.id,
        data.building_by_pk.economic_unit.id,
      );
    },
    fetchPolicy: 'cache-and-network',
  });

  return {
    selectedBuilding: data?.building_by_pk ?? undefined,
    isLoadingBuilding: loading,
    buildingError: error,
  };
};
